<template>
    <div class="fixed top-6 right-6 md:top-8 md:right-8 z-[20]">
        <div @click="openModal" class="md:w-13 md:h-13 
            bg-white 
            flex items-center justify-center 
            rounded-[50%]
            shadow-sm cursor-pointer 
            text-gray-300 
            transition-all duration-300 ease-in-out
            hover:text-[#1E90FF] hover:border-blue-100 
            hover:shadow-md
            overflow-hidden
        ">
            <slot name="icon">
                <svg class="w-7 h-7 md:w-8 md:h-8" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
                </svg>
            </slot>
        </div>

        <BaseModal v-model="isModalOpen" title="用户登录" confirmText="登 录" @confirm="handleLogin">
            <div class="space-y-5 py-2">
                <div class="space-y-1">
                    <label class="text-xs text-gray-400 ml-1">用户名</label>
                    <input type="text" v-model="loginForm.username" @input="errors.username = ''" placeholder="用户名 / 邮箱"
                        :class="['w-full px-4 py-3 bg-gray-50 border rounded-xl outline-none transition-all text-sm',
                            errors.username ? 'border-red-200 bg-red-50/50' : 'border-gray-100 focus:border-blue-200 focus:bg-white']" />
                    <p v-if="errors.username" class="text-[11px] text-red-500 ml-1 mt-1 animate-fade-in">
                        {{ errors.username }}
                    </p>
                </div>

                <div class="space-y-1">
                    <label class="text-xs text-gray-400 ml-1">密 码</label>
                    <input type="password" v-model="loginForm.password" @input="errors.password = ''"
                        placeholder="请输入密码"
                        :class="['w-full px-4 py-3 bg-gray-50 border rounded-xl outline-none transition-all text-sm',
                            errors.password ? 'border-red-200 bg-red-50/50' : 'border-gray-100 focus:border-blue-200 focus:bg-white']" />
                    <p v-if="errors.password" class="text-[11px] text-red-500 ml-1 mt-1 animate-fade-in">
                        {{ errors.password }}
                    </p>
                </div>

                <div class="flex justify-between items-center px-1 text-[11px] text-blue-400 pt-1">
                    <span class="cursor-pointer hover:underline">忘记密码？</span>
                    <span class="cursor-pointer hover:underline">立即注册</span>
                </div>
            </div>
        </BaseModal>
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import BaseModal from './BaseModal.vue';

const isModalOpen = ref(false);

const loginForm = reactive({
    username: '',
    password: ''
});

// 分别存储各个字段的错误信息
const errors = reactive({
    username: '',
    password: ''
});

const openModal = () => {
    errors.username = '';
    errors.password = '';
    loginForm.username = '';
    loginForm.password = '';
    isModalOpen.value = true;
};

const handleLogin = () => {
    // 重置错误
    errors.username = '';
    errors.password = '';

    let hasError = false;

    if (!loginForm.username.trim()) {
        errors.username = '请输入用户名';
        hasError = true;
    }

    if (!loginForm.password.trim()) {
        errors.password = '请输入密码';
        hasError = true;
    }

    if (hasError) return;

    // 模拟登录逻辑
    console.log('登录中...', loginForm);
    isModalOpen.value = false;
};
</script>

<style scoped>
.animate-fade-in {
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>